import { useDropzone } from "react-dropzone";
// Assets
import React, { useState, useEffect } from "react";
import { useImageValidation } from "hooks/useImageValidation";
import { IMAGE_UPLOAD_CONFIG } from "constants/imageUpload";

const DropZonefile = ({ content, formData, handleImageUpload }) => {
  const [file, setFile] = useState(null);
  const { validateFiles, clearErrors } = useImageValidation();
  
  const { getRootProps, getInputProps } = useDropzone({
    accept: IMAGE_UPLOAD_CONFIG.acceptedFormats.reduce((acc, format) => {
      acc[`image/${format === 'jpg' ? 'jpeg' : format}`] = [];
      return acc;
    }, {}),
    maxSize: IMAGE_UPLOAD_CONFIG.maxFileSize,
    onDrop: async (acceptedFiles) => {
      // Clear any previous validation errors
      clearErrors();
      
      if (acceptedFiles.length > 0) {
        const file = acceptedFiles[0];
        
        // Validate the file using our custom hook
        const isValid = await validateFiles([file]);
        
        if (isValid) {
          setFile(file);
          handleImageUpload(file);
        }
      }
    },
  });

  return (
    <div
      className="flex h-full !w-[700px] cursor-pointer items-center justify-center rounded-xl border-dashed border-navy-700"
      {...getRootProps({ className: "dropzone" })}
    >
      <input {...getInputProps()} />
      {formData.picture ? (
        <img
          src={typeof formData.picture === "string" ? formData.picture : URL.createObjectURL(formData.picture)}
          alt="Uploaded"
          name="picture"
          className="max-h-[200px] max-w-[200px] rounded-sm"
        />
      ) : (
        <button type="button" className="h-full w-full">{content}</button>
      )}
    </div>
  );
};

export default DropZonefile;
